import { ComparisonOperator } from '@/apiClient';

export const OPERATOR_OPTIONS: { label: string; value: ComparisonOperator }[] =
  [
    { label: 'Contains', value: ComparisonOperator.Contains },
    { label: 'Equals', value: ComparisonOperator.Equals },
    { label: 'Greater Than', value: ComparisonOperator.GreaterThan },
    { label: 'Less Than', value: ComparisonOperator.LessThan },
    { label: 'Not Equals', value: ComparisonOperator.NotEquals },
  ];

export enum SortDirection {
  Ascending = 0,
  Descending = 1,
}

export const Param = {
  filter: {
    default: '{"items":[]}',
    name: 'filter',
  },
  page: {
    default: 0,
    name: 'page',
  },
  pageSize: {
    default: 50,
    name: 'pageSize',
  },
  searchValue: {
    default: '',
    name: 'searchValue',
  },
  recordStatus: {
    default: [],
    name: 'recordStatus',
  },
  entityStatus: {
    default: [],
    name: 'entityStatus',
  },
  sort: {
    default: '[]',
    name: 'sort',
  },
} as const;
